module.exports = __webpack_public_path__ + "img/table.e591b452.png";